import { React, useState } from 'react';
import { Formik } from 'formik';
import { Navigate, useNavigate } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import Axios from 'axios';
import PmsUrlConfig from '../../urlConfig';
import * as Yup from 'yup';
import ErrorMessages from '../../errorConfig';
import pmsConstants from '../../pmsConstants';
import { logout, setAuthToken } from '../common';

const DeletePatient = () => {
    const settingsDetails = useSelector(state => state.settingsDetails);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const practiceDetails = useSelector(state => state.practiceDetails);
    const loginDetails = useSelector(state => state.loginDetails);
    const [errMsg, setErrMsg] = useState(null);

    if (!loginDetails || loginDetails.jwtToken == null)
        <Navigate replace to={`${PmsUrlConfig.LOGIN_URL}`} />

    const passwordIsValid = settingsDetails.passwordIsValid;
    const curPasswordType = settingsDetails.textboxType;
    const curPwd = settingsDetails.currentPassword;
    const successMsg = practiceDetails.successMsg;
    const errorMsg = practiceDetails.errorMsg;
    const loggedInUser = loginDetails.loggedInUser;
    const token = loginDetails.jwtToken;

    const passwordValidationSchema = Yup.object().shape({
        currentPassword: Yup.string()
            .when("passwordIsValid", {
                is: false,
                then: Yup.string().required('Required'),
            }),

        password: Yup.string()
            .when("passwordIsValid", {
                is: true,
                then: Yup.string().required('Required!'),
            })
            .min(8, ErrorMessages.PASSWORD_LENGTH),


        confPassword: Yup.string()
            .when("passwordIsValid", {
                is: true,
                then: Yup.string().required('Required!'),
            })
            .oneOf([Yup.ref('password')], ErrorMessages.PASSWORDS_DONT_MATCH),
    });


    const validateCurrentPassword = () => {

        var loggedInUserPwd = '';
        if (loggedInUser !== null) {
            loggedInUserPwd = loggedInUser.password;
            console.log("Current Password:", curPwd)
            if (curPwd === null || curPwd === '') {
                setErrMsg('Please enter current password!');
                dispatch({
                    type: 'practiceUpdateError',
                    payload: "Please enter current password!"
                })
            }
            else if (loggedInUserPwd === curPwd) {
                dispatch({
                    type: 'isPasswordValid',
                    payload: true
                })

                setErrMsg(null);
                dispatch({
                    type: 'practiceUpdateError',
                    payload: ""
                })
            }
            else {
                dispatch({
                    type: 'practiceUpdateError',
                    payload: "Incorrect Password"
                })
            }
            console.log(errMsg);
        }
    }
    const handlePwdChange = (cpwd) => {
        dispatch({
            type: 'setCurrentPassword',
            payload: cpwd
        })
    }
 
    const handleNo = () => {
        dispatch({ type: 'isPasswordValid', payload: false });
        dispatch({ type: 'practiceUpdateError', payload: '' });
        dispatch({
            type: 'setCurrentPassword',
            payload: ''
        })
    }
    const handleCancel = () => {
        navigate('/welcome');
    }

    const toggleCurPassword = () => {
        if (curPasswordType === "password") {
            dispatch({
                type: 'setTextboxType',
                payload: "text"
            })

            return;
        }
        dispatch({
            type: 'setTextboxType',
            payload: "password"
        })
    }

    return (

        <Formik
            initialValues={{
                
                currentPassword: '',
            
            }}
            validationSchema={passwordValidationSchema}
            onSubmit={() => {
                // same shape as initial values 
                if (loggedInUser.user_type === pmsConstants.USER_TYPE_PATIENT) {
                    
                    var deletePatientUrl = PmsUrlConfig.BOS_DELETE_PATIENT_ACCOUNT_URL;
                    setAuthToken(token);
                    Axios.delete(deletePatientUrl, {}
                    ).then((response) => {
                        if (response.status === 200) {
                            console.log('Patient account deleted successfully');
                            logout(dispatch);
                            navigate(PmsUrlConfig.LOGIN_URL, { state: { message: `User account deleted successfully!` } });
                        }
                        else if (response.status === 400) {
                            dispatch({
                                type: 'practiceUpdateError',
                                payload: response.data.error_code.description
                            })

                        }
                        else if (response.status === 401 || response.status === 403) {
                            logout();
                            //TODO: Redirect to login page
                        }
                    }).catch((error) => {
                        console.log("-----------------", error)
                        // dispatch({
                        //     type: 'practiceUpdateError',
                        //     payload: error.response.data.error_code.description
                        // })
                    })
                }

            }}
        >
            {({ errors, touched, handleBlur, handleSubmit, isSubmitting }) => (
                <form id="change_password_form" onSubmit={handleSubmit}>
                    <div className="w-full max-w-4xl">
                        {successMsg && <div className='mb-4 p-3 text-green-800 bg-green-100 rounded border border-green-200'>{successMsg}</div>}
                        {errorMsg && <div className='mb-4 p-3 text-red-800 bg-red-100 rounded border border-red-200'>{errorMsg}</div>}

                        {!passwordIsValid &&
                            <div className='space-y-4'>
                                <div className="w-full">
                                    <p className="text-gray-700">Enter current password for {loggedInUser.email}</p>
                                </div>
                                <div className="w-full">
                                    <div className="space-y-2">
                                        <label for="currentPassword" className='block text-sm font-medium text-gray-700 mb-1'>Current Password</label>
                                        <div className="flex flex-col sm:flex-row gap-2">
                                            <div className="flex-1 relative">
                                                <input type={curPasswordType} id="input_curr_password" name="currentPassword"
                                                    required onChange={(e) => handlePwdChange(e.target.value)}
                                                    onBlur={handleBlur}
                                                    className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:border-transparent pr-10 ${errors.currentPassword && touched.currentPassword ? 'border-red-500' : ''}`}
                                                />
                                                {errors.currentPassword && touched.currentPassword ? (
                                                    <div className="text-red-500 text-sm mt-1">{errors.currentPassword}</div>
                                                ) : null}
                                                <button
                                                    type="button"
                                                    onClick={toggleCurPassword}
                                                    className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
                                                >
                                                    {curPasswordType === "password" ?
                                                        <i className="fas fa-eye text-sm"></i>
                                                        :
                                                        <i className="fas fa-eye-slash text-sm"></i>
                                                    }
                                                </button>
                                            </div>
                                            <div className="flex gap-2">
                                                <button
                                                    type="button"
                                                    onClick={validateCurrentPassword}
                                                    className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors duration-200"
                                                >
                                                    Validate
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={handleCancel}
                                                    className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 transition-colors duration-200"
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                        {passwordIsValid &&
                            <div className='space-y-4'>
                                <div className="w-full">
                                    <p className="text-gray-700">Are you sure that you want to delete account <span className="font-semibold">{loggedInUser.email}</span>?</p>
                                </div>
                               
                                <div className="flex flex-col sm:flex-row gap-2">
                                    <button
                                        type="submit"
                                        disabled={isSubmitting}
                                        className="px-6 py-2 h-10 bg-gradient-to-r from-[#0B6D76] to-[#09757F] text-white font-semibold rounded-lg shadow-lg hover:from-[#095C64] hover:to-[#0A6B73] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#0B6D76] transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        Yes
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleNo}
                                        className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 transition-colors duration-200"
                                    >
                                        No
                                    </button>
                                </div>
                            </div>}
                    </div>
                </form>
            )}
        </Formik>

    );

};

export default DeletePatient;